import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "../../lib/cn";

export const inputClass = cn(
  "w-full rounded-md border border-neutral-800 bg-neutral-950 px-2.5 py-1.5",
  "text-sm text-neutral-100 placeholder:text-neutral-500 outline-none",
  "transition-colors focus-visible:border-accent-500",
  "disabled:opacity-50 data-invalid:border-danger-border data-invalid:focus-visible:border-danger-fg",
);

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement> & { invalid?: boolean }>(
  function Input({ className, invalid, ...rest }, ref) {
    return (
      <input
        ref={ref}
        data-invalid={invalid ? "" : undefined}
        className={cn(inputClass, className)}
        {...rest}
      />
    );
  },
);
